module.exports = __webpack_public_path__ + "static/media/quickco-logo.da9de672.jpg";